import { render, staticRenderFns } from "./DialogDeleteMultiplePosts.vue?vue&type=template&id=017d6c44&"
import script from "./DialogDeleteMultiplePosts.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteMultiplePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports